import React, { useEffect, Fragment } from "react";
import { Link } from "react-router-dom";
import PageHelmet from "../../component/common/Helmet";
import Breadcrumb from "../../elements/common/Breadcrumb";
import ScrollToTop from "react-scroll-up";
import { FiChevronUp } from "react-icons/fi";
import Header from "../../component/header/Header";
import Footer from "../../component/footer/Footer";
import { useTranslation } from "react-i18next";
import ProjectList from "./ProjectList";

const Project = () => {
  const { i18n } = useTranslation();
  const isEnglish = i18n.language === "en";

  return (
    <>
     
      <Header
        headertransparent="header--transparent"
        colorblack="color--black"
        logoname="logo.png"
      />
   
      <Breadcrumb title={"Project Research"} />
     
      <main className="page-wrapper">
        <div className="project-area ptb--120 bg_color--5">
          <div className="project-sacousel-inner">
            <div className="container">
              <div className="row">
                <div className="col-lg-12">
                  <div className="section-title text-center">
                    <span className="subtitle">
                      {isEnglish ? "Project Research" : "Projets de recherche"}
                    </span>
                    <h2 className="title">
                      {isEnglish
                        ? "Our Latest projects"
                        : "Nos derniers projets"}
                    </h2>
                  </div>
                </div>
              </div>

              <ProjectList />
            </div>
          </div>
        </div>
        
      </main>
    
      <div className="backto-top">
        <ScrollToTop showUnder={160}>
          <FiChevronUp />
        </ScrollToTop>
      </div>
      
      <Footer />
    </>
  );
};

export default Project;
